import { render, staticRenderFns } from "./sin-examen.vue?vue&type=template&id=6fde681b&"
import script from "./sin-examen.vue?vue&type=script&lang=js&"
export * from "./sin-examen.vue?vue&type=script&lang=js&"
import style0 from "./sin-examen.vue?vue&type=style&index=0&id=6fde681b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports